export default class AmplitudeTaskParameters {
	static fromJSON(json) {
		if (!json) return null

		const amplitudeTaskParameters = new AmplitudeTaskParameters()
			.withProcessId(json.processId)
			.withRequisitionId(json.requisitionId)
			.withAppointmentId(json?.appointmentId)
			.withTaskCreationDate(json.createdAt)
			.withTaskOwner(json?.user?.name)
			.withRequisitionState(json?.requisitionState)
			.withTaskType(json.type)

		return amplitudeTaskParameters
	}

	constructor() {
		this.dataEvento = new Date()
	}

	withProcessId(processId) {
		this.idProcesso = processId
		return this
	}

	withRequisitionId(requisitionId) {
		this.idRequisicao = requisitionId ? requisitionId : undefined
		return this
	}
	withAppointmentId(appointmentId) {
		this.idConsulta = appointmentId ? appointmentId : undefined
		return this
	}

	withTaskCreationDate(createdAt) {
		this.dataCriacaoTarefa = createdAt
		return this
	}

	withTaskOwner(name) {
		this.userAlocadoTarefa = name
		return this
	}

	withRequisitionState(requisitionState) {
		this.estadoRequisicao = requisitionState
		return this
	}

	withTaskType(type) {
		this.tipoTarefa = type
		return this
	}
}
